export const filterFns = {
  // Text filters
  text: {
    Equals: (cell, val) => cell.toLowerCase() === val.toLowerCase(),
    "Does Not Equal": (cell, val) => cell.toLowerCase() !== val.toLowerCase(),
    "Begins With": (cell, val) => cell.toLowerCase().startsWith(val.toLowerCase()),
    "Ends With": (cell, val) => cell.toLowerCase().endsWith(val.toLowerCase()),
    "Contains": (cell, val) => cell.toLowerCase().includes(val.toLowerCase()),
    "Does Not Contain": (cell, val) => !cell.toLowerCase().includes(val.toLowerCase())
  },
  
  // Number filters
  number: {
    Equals: (cell, val) => Number(cell) === Number(val),
    "Greater Than": (cell, val) => Number(cell) > Number(val),
    "Less Than": (cell, val) => Number(cell) < Number(val)
  },
  
  // Date filters
  date: {
    Equals: (cell, val) => new Date(cell).getTime() === new Date(val).getTime(),
    Before: (cell, val) => new Date(cell).getTime() < new Date(val).getTime(),
    After: (cell, val) => new Date(cell).getTime() > new Date(val).getTime()
  }
};

export const getFilterFunction = (type, filterType) => {
  return filterFns[type]?.[filterType] || filterFns.text[filterType];
}; 